<template>
  <div >
    <el-select
        class="fl wid15"
        v-model="form.collegeId"
        placeholder="学院"
        @input="collegeChange(form.collegeId,'reset')">
        <el-option v-for="item in collegeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select  class="fl wid15"  v-model="form.majorId" @input="majorChange(form.majorId,'reset')"  placeholder="专业" style="margin:0 10px;">
        <el-option v-for="item in majorData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select  class="fl wid15" v-model="form.gradeId" @input="gradeChange(form.gradeId,'reset')"  placeholder="年级">
        <el-option v-for="item in gradeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select  class="fl wid15" v-model="form.classId"  placeholder="班级" style="margin:0 10px;">
        <el-option v-for="item in classData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
  </div>
</template>

<script>
let schoolById = JSON.parse(localStorage.getItem("USER")).schoolId;
export default {
  data() {
    return {
       // 学院参数
      paramCollege: {
        showItem: 1000,
        schoolId: schoolById,
        pageIndex: 1,
        word: ""
      },
      paramMajor: {
        collegeId: 0,
        schoolId: schoolById
      }, // 获取专业参数
        classData: [], // 班级
      gradeData: [], // 年级
      majorData: [], // 专业
      schoolData: [],
      collegeData: [], // 学院
      form: {
        files: null,
        collegeId: null, // 学院id
        schoolId: Number(schoolById), // 高校id
        majorId: null, // 专业id
        gradeId: null, // 年级
        classId: null // 班级
      },
    };
  },

  methods: {
     ngOnInit() {
      // 获取学院列表
      const paramSchool = {
        word: ""
      };
      // 高校select
      this.$api.allianceSchool.getSchoolList(paramSchool).then(res => {
        if (res.errCode == 0) {
          this.schoolData = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
      // if (this.$route.query.studentId) {
      //   const param = {
      //     schoolId: schoolById,
      //     studentId: this.$route.query.studentId
      //   };
      //   this.getStudentInfo(param);
      // }
    },
        // 高校下拉框获取学院select
    getSchoolChange() {
      this.$api.allianceSchool.getCollegeList(this.paramCollege).then(res => {
        if (res.errCode == 0) {
          this.collegeData = res.data.items;
            // 学院
            this.form.collegeId = null;
            // 专业
            this.form.majorId = null;
            this.majorData = [];
            // 年级
            this.form.gradeId = null;
            this.gradeData = [];
            // 班级
            this.form.classId = null;
            this.classData = [];
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 学院获取专业下拉框
    collegeChange(res, type) {
      this.paramMajor.collegeId = res;
      this.$api.allianceSchool.getMajorList(this.paramMajor).then(item => {
        if (item.errCode == 0) {
          this.majorData = item.data;
          if (type == "reset") {
            // 专业
            this.form.majorId = null;
            // 年级
            this.form.gradeId = null;
            this.gradeData = [];
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 专业获取年级下拉框
    majorChange(res, type) {
      const param = {
        majorId: res,
        schoolId: this.paramCollege.schoolId
      };
      this.$api.allianceSchool.getGradeList(param).then(item => {
        if (item.errCode == 0) {
          this.gradeData = item.data;
          if (type == "reset") {
            // 年级
            this.form.gradeId = null;
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 获取班级
    gradeChange(res, type) {
      const param = {
        gradeId: res,
        schoolId: this.paramCollege.schoolId
      };
      this.$api.allianceSchool.collegeMgrGetClassList(param).then(item => {
        if (item.errCode == 0) {
          this.classData = item.data;
          if (type == "reset") {
            // 班级
            this.form.classId = null;
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    paramInit(){
      const param = {
        classId:this.form.classId,//班级
        collegeId:this.form.collegeId,//学院id
        gradeId:this.form.gradeId,//年级id
        majorId:this.form.majorId,//专业id
      }
      return param
    },
    resetInit(){
      this.form = {
              files: null,
              collegeId: null, // 学院id
              schoolId: Number(schoolById), // 高校id
              majorId: null, // 专业id
              gradeId: null, // 年级
              classId: null // 班级
            }
      this.classData= []; // 班级
      this.gradeData = []; // 年级
      this.majorData = []; // 专业
    }
  },
  created() {
    this.getSchoolChange()
    // this.ngOnInit();
  }
};
</script>
<style lang='less' scoped>
.wid15{
  width: 150px;
}
</style>